import React, { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import { useHistory } from "react-router-dom";
import { BASEURL } from "components/Utils/Constants";
import Logo from "i/pickaxe.svg";
import { identifyUser } from "../utils/analytics";

const Sso = () => {
  const history = useHistory();
  const { isLoading, isAuthenticated, error, getIdTokenClaims } = useAuth0();
  const [userHasProjectAccess, setUserProjectAccess] = useState(false);
  const [defaultTenantName, setDefaultTenantName] = useState(null);

  const redirectReferrer = window.localStorage.getItem("sso_redirect");

  const contacts = {
    Telemundo: "seamus.czprathstein@nbcuni.com",
  };

  useEffect(() => {
    const setItem = window.localStorage.setItem.bind(window.localStorage);

    const ssoOptions = (props) => {
      const { token, user, roles, permissions } = props;

      if (user) {
        let defaultTenant = user.tenants.find(
          (tenant) => tenant.slug === user.tenant
        );

        // check for referrer url and find tenant id
        if (redirectReferrer && !redirectReferrer.includes("/")) {
          const projectFromUrl = redirectReferrer?.split("/")[1];

          defaultTenant = user.tenants.find((tenant) =>
            tenant.projects.find((project) => project.slug === projectFromUrl)
          );
        }

        setDefaultTenantName(defaultTenant?.name);

        // Check if a user has access to at least one project
        if (defaultTenant?.projects?.length > 0) {
          setItem("token", token);
          setItem("user", user.firstName);
          setItem("email", user.email);
          setItem(
            "roles",
            roles.map((v) => v.name)
          );
          setItem("permissions", JSON.stringify(permissions));
          setItem("defaultTenantID", defaultTenant.id);
          setItem("defaultTenantSlug", defaultTenant.slug);

          // Set defaultProjectID to the first available project
          if (defaultTenant.projects[0] && defaultTenant.projects[0].id) {
            setItem("defaultProjectID", defaultTenant.projects[0].id);
          }

          // Use the new identifyUser function
          identifyUser(user);

          window.localStorage.removeItem("sso_redirect");
          history.push(redirectReferrer);
        } else {
          setUserProjectAccess(true);
        }
      }
    };

    const callAPI = async () => {
      const claims = await getIdTokenClaims();

      fetch(`${BASEURL}/auth0/login`, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id_token: claims.__raw,
        }),
      })
        .then((res) => res.json())
        .then((res) => ssoOptions(res));
    };

    if (isAuthenticated && !isLoading) {
      callAPI();
    }
  }, [
    isLoading,
    isAuthenticated,
    getIdTokenClaims,
    setUserProjectAccess,
    history,
    redirectReferrer,
  ]);

  // Generic authentication error
  const errorMessages = () => {
    let params = new URLSearchParams(document.location.search);
    let error_param = params.get("error");

    return (
      <>
        <h2 className="sso-title">There was a problem logging in.</h2>
        <p>Error: {error_param}</p>
        <p>
          Please return to the <a href="/">login</a> page and try again.
        </p>
      </>
    );
  };

  // Authenticated user without project access
  const accessMessage = () => {
    const contact = contacts[defaultTenantName];

    return (
      <>
        <h2 className="sso-title">Welcome To Pickaxe.</h2>
        <p>
          Sorry, it looks like you haven't been granted access to any projects
          yet. <br />
          Please contact your admin to get access:
        </p>
        <p>
          <b>{contact}</b>
        </p>
      </>
    );
  };

  return (
    <main className="login">
      <section className="login-left">
        <div className="login-beta">beta</div>
        <div className="login-intro">
          <a href="/" className="mb-5 d-inline-block">
            <img src={Logo} alt="Pickaxe" className="login__logo" />
          </a>
          <h1 className="login-intro__title">
            It's your data. We just make it useful.
          </h1>
        </div>
        <div className="login-copyrights">
          @ {new Date().getFullYear()} Pickaxe Foundry, Inc
        </div>
      </section>
      <section className="login-right">
        <div className="text-left sso-message">
          {userHasProjectAccess && accessMessage()}
          {error && errorMessages()}
          {!error && !userHasProjectAccess && (
            <div className="login-sso-message text-center">
              <p className="login-sso-message--text">Redirecting...</p>
            </div>
          )}
        </div>
      </section>
    </main>
  );
};

export default Sso;
